import { of } from 'rxjs';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, catchError, exhaustMap, tap } from 'rxjs/operators';

import * as actions from '@appStore/customers/actions';
import { CustomerUsersActionTypes, CustomerUsersLoadData } from '@appStore/customers/actions/customer-users.actions';
import { CustomerService } from '@appStore/customers/services';

@Injectable()
export class CustomerUsersEffects {
  constructor(private customerService: CustomerService, private actions$: Actions, private router: Router) {}

  loadMyCustomersUsers$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CustomerUsersActionTypes.CustomerUsersLoadData),
      exhaustMap((action: CustomerUsersLoadData) => {
        return this.customerService.getMyCustomerUsers(action.payload).pipe(
          map(customerUsers => new actions.CustomerUsersLoadSuccess(customerUsers)),
          catchError(error => of(new actions.CustomerUsersLoadFail(error)))
        );
      })
    );
  });
  
  updateCustomerUser$ = createEffect(() => {
    return   this.actions$.pipe(
      ofType(CustomerUsersActionTypes.UpdateCustomerUser),
      map((action: actions.UpdateCustomerUser) => action.payload),
      exhaustMap(customerUser =>
        this.customerService.updateCustomerUser(customerUser).pipe(
          map(item => new actions.UpdateCustomerUserSuccess(item)),
          catchError(error => of(new actions.UpdateCustomerUserFail(error)))
        )
      )
    );
  });

  bulkUpdateCustomerUser$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CustomerUsersActionTypes.BulkUpdateCustomerUser),
      map((action: actions.BulkUpdateCustomerUser) => action.payload),
      exhaustMap(customerUsers =>
        this.customerService.bulkUpdateCustomerUser(customerUsers).pipe(
          map(item => new actions.BulkUpdateCustomerUserSuccess(item)),
          catchError(error => of(new actions.BulkUpdateCustomerUserFail(error)))
        )
      )
    );
  });
  
  addCustomerUser$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CustomerUsersActionTypes.CreateCustomerUser),
      map((action: actions.CreateCustomerUser) => action.payload),
      exhaustMap(customerUser =>
        this.customerService.addCustomerUser(customerUser).pipe(
          map(item => new actions.CreateCustomerUserSuccess(item)),
          catchError(error => of(new actions.CreateCustomerUserFail(error)))
        )
      )
    );
  });
  
  setPrimaryCustomerUser$ = createEffect(() => {
    return   this.actions$.pipe(
      ofType(CustomerUsersActionTypes.SetPrimaryCustomerUser),
      map((action: actions.UpdateCustomerUser) => action.payload),
      exhaustMap(customerUser =>
        this.customerService.setPrimaryCustomerUser(customerUser).pipe(
          map(item => new actions.SetPrimaryCustomerUserSuccess(item)),
          catchError(error => of(new actions.SetPrimaryCustomerUserFail(error)))
        )
      )
    );
  });

  removeCustomerUser$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CustomerUsersActionTypes.CustomerUserRemove),
      map((action: actions.CustomerUserRemove) => action.payload),
      exhaustMap(customerUser =>
        this.customerService.removeCustomerUser(customerUser).pipe(
          map(() => new actions.CustomerUserRemoveSuccess(customerUser)),
          catchError(error => of(new actions.CustomerUserRemoveFail(error)))
        )
      )
    );
  });

  bulkRemoveCustomerUser$ = createEffect(() => {
    return  this.actions$.pipe(
      ofType(CustomerUsersActionTypes.BulkRemoveCustomerUser),
      map((action: actions.BulkRemoveCustomerUser) => action.payload),
      exhaustMap(customerUsers =>
        this.customerService.bulkRemoveCustomerUser(customerUsers).pipe(
          map(item => new actions.BulkRemoveCustomerUserSuccess(item)),
          catchError(error => of(new actions.BulkRemoveCustomerUserFail(error)))
        )
      )
    );
  });
}
